module.exports = __webpack_public_path__ + "static/mushroom-f5080759f593ca466a5bcc8c815b0132.jpg";